import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { useAirModal } from "@air/provider-modal";
import { PlansModal } from "~/components/Modals/PlansModal/PlansModal";
import { SETTINGS_UPGRADE_NOTICE } from "~/constants/testIDs";
import { useSubscriptionContext } from "~/providers/SubscriptionProvider";
export const SettingsUpgradeNotice = ()=>{
    const [showPlansModal] = useAirModal(PlansModal);
    const { data: subscription } = useSubscriptionContext();
    if ((subscription === null || subscription === void 0 ? void 0 : subscription.isOnPlusPlan) || (subscription === null || subscription === void 0 ? void 0 : subscription.isOnProPlan)) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-3 rounded-lg bg-blue-3 p-4",
        "data-testid": SETTINGS_UPGRADE_NOTICE,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-16 font-bold text-blue-12",
                children: "Upgrade for more sharing features"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-14",
                children: (subscription === null || subscription === void 0 ? void 0 : subscription.isInFreePlan) ? "Enhance your workflow with tools like comments, editable custom fields, and security options including passcodes and expiration settings." : "Enhance your workflow with tools like editable custom fields and security options including passcodes and expiration settings."
            }),
            /*#__PURE__*/ _jsx(Button, {
                appearance: "filled",
                color: "blue",
                size: "large",
                className: "w-fit",
                onClick: showPlansModal,
                children: "Upgrade to access"
            })
        ]
    });
};
